module.exports = __webpack_public_path__ + "static/day2-9c16849dc09442cf80efd1318e52831f.webm";